<div class="modal-header" *ngIf="showAsDialog">
    <h4 class="modal-title">Parts and Frames</h4>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="m-2 grid-fill" [ngStyle]="{ height: showAsDialog ? '600px' : '100%' }" *ngIf="partsWithFrame">
        <dx-data-grid
            #dataGrid
            [dataSource]="partsWithFrame"
            keyExpr="frameId"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="part" caption="Trailer Part #" width="210"></dxi-column>
            <dxi-column dataField="orderNew" caption="Order[new]" width="70"></dxi-column>
            <dxi-column dataField="frame" caption="Frame" width="350"></dxi-column>
            <dxi-column dataField="frameInStock" caption="Frame Proj. Inventory" width="70"></dxi-column>
            <dxi-column dataField="frameOrderNew" caption="FrameOrder[new]" width="70"></dxi-column>
            <dxi-column  width="70"></dxi-column>

            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-search-panel *ngIf="!showAsDialog" class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export *ngIf="!showAsDialog" [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="!showAsDialog" type="localStorage" storageKey="part-frame-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
            </div>
        </dx-data-grid>
    </div>

    <div>
        <dx-toast message="Changes Saved!" type="success" [displayTime]="500" [maxWidth]="300" [position]="'bottom right'" [(visible)]="isToastVisible"> </dx-toast>
    </div>
</div>
<div class="modal-footer" *ngIf="showAsDialog">
    <button type="button" (click)="select()" class="btn btn-success ms-3">Save & Close</button>
    <button type="button" (click)="cancel()" class="btn btn-secondary ms-1">Cancel</button>
</div>
